import * as SC from './LoaderStyles';

import LoaderIcon from '@/assets/icons/loader.svg?react';

type Props = {
  className?: string;
};

export const Loader = ({ className }: Props) => {
  return (
    <SC.IconWrapper className={className}>
      <LoaderIcon />
    </SC.IconWrapper>
  );
};
